enum CurvaABCConsiderarPrescritor {
    Valor = 1,
    Formula = 2,
}

export default CurvaABCConsiderarPrescritor;
